// src/components/layout/Footer.js
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    useEffect(() => {
        console.log("[Footer] MONTADO");
        return () => console.log("[Footer] DESMONTADO");
    }, []);
    return (
        <footer
            className="bg-dark text-light text-center py-3 mt-auto"
            style={{ fontSize: "0.9rem" }}
        >
            <div>
                © {new Date().getFullYear()} Teamociones
            </div>
            <div>
                <Link to="/cookies" className="text-light">
                    Política de cookies
                </Link>
            </div>
        </footer>
    );
}

export default Footer;